import {ParserRuleContext} from 'antlr4';
import RestrictionsVisitor from './antlr4/RestrictionsVisitor.js';
import {Hiccup} from './types.js';

const visitor = new RestrictionsVisitor<Hiccup | Hiccup[]>();

const inline = (ctx: ParserRuleContext) => {
    const children = visitor.visitChildren(ctx);
    return children.length == 1 ? children[0] as Hiccup[] : children;
};
visitor.visitParse = ctx => ctx.expr().accept(visitor);
visitor.visitExpr = ctx => {
    return ['expr', inline(ctx)];
};
visitor.visitAndOrEqNeq = inline;
visitor.visitEqNeqTerm = inline;
visitor.visitTerm = ctx => {
    if (ctx.getChildCount() === 3) {
        // lparen andOr rparen
        return visitor.visit(ctx.getChild(1));
    }
    return inline(ctx);
};
visitor.visitEq = ctx => {
    const lhs = inline(ctx.eqNeq());
    const rhs = ctx.term().accept(visitor);
    return ['eq', lhs, rhs];
}
visitor.visitNeq = ctx => {
    const lhs = inline(ctx.eqNeq());
    const rhs = ctx.term().accept(visitor);
    return ['neq', lhs, rhs];
}
visitor.visitMatch = ctx => {
    return ['match', visitor.visitChildren(ctx.eqNeq())[0], ctx.term().accept(visitor)]
}
visitor.visitAnd = ctx => {
    const lhs = visitor.visitChildren(ctx.andOr());
    const rhs = visitor.visitChildren(ctx.eqNeq());
    return ['and', lhs[0], rhs[0]];
}
visitor.visitIdent = (ctx) => {
    return ['ident', ctx.word().accept(visitor)];
};
visitor.visitOwnIdent = (ctx) => {
    return ['own-ident', ctx.word().accept(visitor)];
};
visitor.visitWord = ctx => ['word', ctx.WORD().symbol.text];
visitor.visitNumber = (ctx) => {
    return ['number', ctx.NUMBER().symbol.text];
};
visitor.visitStr = (ctx) => {
    return ['str', ctx.STR().symbol.text.slice(1, -1)];
};

export default visitor;
